import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgBustAudience(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 39.5C12.5 21.55 25.931 7 42.5 7h36c16.569 0 30 14.55 30 32.5S95.069 72 78.5 72h-36c-16.569 0-30-14.55-30-32.5Z"
        fill="#E6F4F0"
      />
      <path
        d="M60.5 11.8c8.946 0 16.2 7.253 16.2 16.2v4.099l1.86 10.825c.101.583.276 1.144.472 1.833 1.604 5.652-1.643 11.665-7.428 13.318L60.83 61.153l-.358.103-13.327-4.443a7.2 7.2 0 0 1-4.793-8.183L44.3 32.125V28c0-8.947 7.253-16.2 16.2-16.2Z"
        fill="#0F172A"
      />
      <path
        d="M66.397 54H54.603a24 24 0 0 0-23.076 17.407l-4.842 16.945C25.59 92.184 28.468 96 32.455 96h56.09c3.987 0 6.865-3.816 5.77-7.648l-4.842-16.945A24 24 0 0 0 66.397 54Z"
        fill="#78B441"
      />
      <path
        d="M88.545 96h-56.09c-3.831 0-6.639-3.524-5.88-7.2.936 1.84 2.825 3 4.89 3h58.07a5.486 5.486 0 0 0 4.89-3c.758 3.676-2.049 7.2-5.88 7.2ZM42.5 72v12h13.2c1.8 0 4.8 1.2 4.8 1.2s3-1.2 4.8-1.2h13.2V72c-8.059 12-27.941 12-36 0Z"
        fill="#599F40"
      />
      <path
        d="M46.7 84.6a.6.6 0 0 0 .536-.869c-1.176-2.353-2.962-7.11-4.154-11.877A.6.6 0 0 0 41.9 72v12a.6.6 0 0 0 .6.6h4.2Zm-3.6-8.287c.877 2.787 1.848 5.323 2.652 7.087H43.1v-7.087ZM78.5 84V72c-1.2 4.8-3 9.6-4.2 12h4.2Z"
        fill="#0F172A"
      />
      <path
        d="M53.9 95.4c0-4.162 2.12-7.828 5.335-9.98a10.763 10.763 0 0 0-4.135-.82H42.5c-2.797 0-5.029 1.1-7.027 3.668a.6.6 0 1 1-.947-.736c2.063-2.653 4.447-3.962 7.374-4.117V72a.6.6 0 0 1 1.2 0v11.4h12c1.941 0 3.776.462 5.4 1.281a11.952 11.952 0 0 1 5.4-1.281h12V72a.6.6 0 1 1 1.2 0v11.415c2.927.155 5.31 1.465 7.373 4.117a.6.6 0 1 1-.947.736c-1.998-2.569-4.23-3.668-7.026-3.668H65.9a10.797 10.797 0 0 0-10.8 10.8.6.6 0 0 1-1.2 0ZM32.999 80.408l3.6.6a.6.6 0 1 1-.198 1.184l-3.6-.6A.6.6 0 0 1 33 80.41Zm55.003 0a.6.6 0 0 1 .197 1.184l-3.6.6a.6.6 0 0 1-.198-1.184l3.6-.6Zm-51.77-11.345a.6.6 0 0 1 .805.268l1.8 3.601a.6.6 0 0 1-1.074.536l-1.8-3.6a.6.6 0 0 1 .27-.805Z"
        fill="#0F172A"
      />
      <path
        d="M42.5 84V72c1.2 4.8 3 9.6 4.2 12h-4.2ZM74.3 84.6a.6.6 0 0 1-.536-.869c1.176-2.353 2.962-7.11 4.154-11.877A.6.6 0 0 1 79.1 72v12a.6.6 0 0 1-.6.6h-4.2Zm3.6-8.287c-.877 2.787-1.848 5.323-2.652 7.087H77.9v-7.087Z"
        fill="#0F172A"
      />
      <path d="M57.5 45h6v9a3 3 0 0 1-6 0v-9Z" fill="#A6DBCB" />
      <path d="M57.5 54a3 3 0 0 0 6 0h-6Z" fill="#A6DBCB" />
      <path
        d="M63.5 52.5A1.5 1.5 0 0 1 65 54a4.5 4.5 0 0 1-9 0 1.5 1.5 0 0 1 1.5-1.5h6Z"
        fill="#fff"
      />
      <path
        d="M61.111 55.859a3 3 0 0 1 3.53 2.353l1.8 9a3 3 0 0 1-5.882 1.176l-.059-.293-.059.293a3 3 0 0 1-5.882-1.176l1.8-9a3 3 0 0 1 4.141-2.161 3.01 3.01 0 0 1 .611-.192Z"
        fill="#fff"
      />
      <path
        d="M66.324 66.624a.6.6 0 0 1 .706.47 3.6 3.6 0 0 1-6.53 2.696 3.6 3.6 0 0 1-6.53-2.696.6.6 0 0 1 1.177.235 2.4 2.4 0 0 0 4.706.941l.059-.29a.6.6 0 0 1 1.176 0l.059.29a2.4 2.4 0 0 0 4.706-.941.6.6 0 0 1 .47-.705ZM59.9 65.4v-7.8a.6.6 0 1 1 1.2 0v7.8a.6.6 0 1 1-1.2 0Z"
        fill="#0F172A"
      />
      <path d="M57.5 47.4h6v3c-2.4 0-4.8-1.2-6-3Z" fill="#5BBDA0" />
      <path d="M114.5 108H6.5l6-12h96l6 12Z" fill="#599F40" />
      <path
        d="M108.5 95.4a.6.6 0 0 1 .537.331l6 12a.601.601 0 0 1-.537.869H6.5a.6.6 0 0 1-.537-.869l6-12 .043-.072a.6.6 0 0 1 .494-.259h96Zm-101.03 12H113.53l-5.4-10.8H12.871l-5.4 10.8Z"
        fill="#599F40"
      />
      <path d="M103.7 95.4a.6.6 0 1 1 0 1.2H17.3a.6.6 0 1 1 0-1.2h86.4Z" fill="#0F172A" />
      <path
        d="M60.5 18c.018.044 4.52 11.273 10.323 13.214A2.368 2.368 0 0 1 72.5 30.5c1.38 0 2.5 1.231 2.5 2.75S73.88 36 72.5 36c-.08 0-.16-.005-.239-.014L72.26 36c-1.112 6.847-5.954 12-11.76 12-5.805 0-10.648-5.153-11.76-12 0-.005 0-.01-.002-.016-1.257-.143-2.238-1.312-2.238-2.734 0-1.519 1.12-2.75 2.5-2.75l.308-.009C55.752 30.113 60.5 18 60.5 18Z"
        fill="#A6DBCB"
      />
      <path
        d="M60.5 37.2c1.002 0 1.79.72 2.072 1.621a.6.6 0 1 1-1.144.358c-.155-.497-.545-.78-.928-.78s-.773.283-.928.78a.6.6 0 1 1-1.144-.358c.281-.901 1.07-1.62 2.072-1.62ZM55.82 41.04a.601.601 0 0 1 .84-.12c1.089.816 2.726 1.358 4.341 1.088a.6.6 0 1 1 .198 1.184c-1.985.33-3.948-.328-5.26-1.312a.601.601 0 0 1-.12-.84Z"
        fill="#0F172A"
      />
      <path d="M95.3 93V67.8a1.2 1.2 0 0 1 2.4 0V93a1.2 1.2 0 0 1-2.4 0Z" fill="#80CCB5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.5 95.4a4.8 4.8 0 0 1 4.8-4.8h2.4a4.8 4.8 0 0 1 4.8 4.8h-12Z"
        fill="#80CCB5"
      />
      <path
        d="M97.7 88.2a7.2 7.2 0 0 1 7.2 7.2 2.4 2.4 0 0 1-2.4 2.4h-12a2.4 2.4 0 0 1-2.4-2.4 7.2 7.2 0 0 1 7.2-7.2h2.4ZM97.1 55.8l-12 12a4.243 4.243 0 0 0 6 6l12-12a4.242 4.242 0 1 0-6-6Z"
        fill="#0F172A"
      />
      <path
        d="M96.676 55.376a4.842 4.842 0 1 1 6.848 6.848l-12 12a4.841 4.841 0 1 1-6.848-6.848l12-12Zm6 .848a3.644 3.644 0 0 0-5.152 0l-12 12a3.644 3.644 0 0 0 5.152 5.152l12-12a3.643 3.643 0 0 0 0-5.152Z"
        fill="#0F172A"
      />
      <path
        d="M89.827 60.528a1.8 1.8 0 0 1 2.545 0l6 6a1.8 1.8 0 1 1-2.545 2.544l-6-6a1.8 1.8 0 0 1 0-2.544Z"
        fill="#80CCB5"
      />
    </svg>
  )
}
export default wrapIllustration(SvgBustAudience)
